import Modal from 'react-modal';
import '../../App.css';

import { Atom, Commet, Mosaic } from "react-loading-indicators";
import { useEffect, useState } from 'react';
import { data } from 'react-router-dom';


function Spinner() {
  

   
          return<>
          
          <div className='spinner8'  >


           <Mosaic color="#073007" size="medium" text="" textColor="#650f0f" />
    
    
          
          </div>
        </>
  

              
}



export default Spinner